import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { VehicleService } from '@app/modules/core/services/vehicle/vehicle.service';
import { MissingCarFormPayload } from '@app/modules/shared/models';

/**
 * > Shows form when Client doesn't find his/her brand-model car option.
 */
@UntilDestroy()
@Component({
  selector: 'bkg-vehicle-dialog-not-found-form',
  templateUrl: './vehicle-dialog-not-found-form.component.html',
})
export class VehicleDialogNotFoundFormComponent implements OnInit {
  @Output() errorReturn = new EventEmitter<HttpErrorResponse>();
  @Output() closeModalReturn = new EventEmitter<boolean>();
  @Input() isLogged: boolean;

  missingCarModelForm: FormGroup;

  constructor(
    private vehicleService: VehicleService,
    public formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.missingCarModelForm = this.formBuilder.group({
      make: ['', [Validators.required]],
      model: ['', [Validators.required]],
    });
    if (!this.isLogged) {
      this.createMissingCarModelForm();
    }
  }

  private createMissingCarModelForm(): void {
    this.missingCarModelForm.addControl(
      'email',
      new FormControl('', Validators.required)
    );
  }

  get emailControl(): AbstractControl | null {
    return this.missingCarModelForm.get('email') || null;
  }

  sendMissingCarModel(): void {
    const payload = this.createPayload();

    if (this.isLogged) {
      this.sendMissingCarModelLogged(payload);
    } else {
      this.sendMissingCarModelGuest(payload);
    }
  }

  private createPayload = (): MissingCarFormPayload => {
    const payload = {
      brand: this.missingCarModelForm.get('make').value as string,
      model: this.missingCarModelForm.get('model').value as string,
      email: this.missingCarModelForm.get('email')?.value as string,
    } as MissingCarFormPayload;

    return payload;
  };

  private sendMissingCarModelLogged = (
    payload: MissingCarFormPayload
  ): void => {
    this.vehicleService
      .sendMissingCarModel(payload)
      .pipe(untilDestroyed(this))
      .subscribe(
        () => this.closeModalReturn.emit(true),
        (error: HttpErrorResponse) => this.errorReturn.emit(error)
      );
  };

  private sendMissingCarModelGuest = (payload: MissingCarFormPayload): void => {
    this.vehicleService
      .sendMissingCarModelGuest(payload)
      .pipe(untilDestroyed(this))
      .subscribe(
        () => this.closeModalReturn.emit(true),
        (error: HttpErrorResponse) => this.errorReturn.emit(error)
      );
  };
}
